import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScHostSetting implements ICommand
{

	public HostID : number = 0;
	public HostMsg : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.HostMsg = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeString(this.HostMsg);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScHostSetting();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'HostMsg(S)='+this.HostMsg+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30052;
	}

	public getCmdName() : string
	{
		return 'ScHostSetting';
	}

}
